// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__w7h68","basketContainer":"Loading_basketContainer__s150T"};